export default "__VITE_ASSET__TiP8kcmO__"